<template>
	<div>
		<table class="table mt-2">
			<thead>
				<tr>
					<th scope="col" :class="colClass">Test</th>
					<th v-if="mode==='dashboard'" scope="col" class="col-2">Service</th>
					<template v-if="mode!=='select'">
						<th scope="col" class="col-2">Duration</th>
						<th scope="col" class="col-2">Result</th>
						<th scope="col" class="col-2">Status</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(test, index) in tests" :key="index" :class="{'text-muted': test.status===RUN_STATUS.SKIPPED}">
					<td>
						<label v-if="mode==='select'">
							<input
								type="checkbox"
								v-model="test.action"
								:true-value="RUN_ACTION.RUN"
								:false-value="RUN_ACTION.SKIP"
							/>
							{{ test.fullPath }}
						</label>
						<a v-else-if="test.link" :href="test.link" target="_blank" :class="{'text-muted': test.status===RUN_STATUS.SKIPPED}">{{ test.fullPath }}</a>
						<span v-else>{{ test.fullPath }}</span>
					</td>
					<td v-if="mode==='dashboard'">
						{{ test.serviceId }}<small class="text-muted"> ({{ test.serviceTag }})</small>
					</td>
					<template v-if="mode!=='select'">
						<td>
							{{ getDuration(test) }}
						</td>
						<td>
							<TestResult :result="test.result" @previewResult="previewResult"/>
						</td>
						<td :class="STATUS_CLASSES[test.status]">
							{{ test.status }}
							<template v-if="test.status===RUN_STATUS.RUNNING">
								<Loading />
								<button
									title="Stop"
									class="btn btn-danger"
									@click="cancelTest(test)"
								>
									<i class="fas fa-times"></i>
								</button>
							</template>
						</td>
					</template>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { RUN_STATUS, RUN_ACTION, STATUS_CLASSES } from '../../util/test-runner-constants';
import { convertDuration } from '../../util/test-runner';
import TestResult from './TestResult';
import Loading from '../shared/Loading';

export default {
	name: 'TestsTable',
	props: ['tests', 'mode'],
	components: {
		TestResult,
		Loading
	},
	created() {
		this.RUN_ACTION = RUN_ACTION;
		this.RUN_STATUS = RUN_STATUS;
		this.STATUS_CLASSES = STATUS_CLASSES;
	},
	computed: {
		colClass() {
			return this.mode === 'select' ? 'col' : (this.mode === 'dashboard' ? 'col-4' : 'col-6');
		}
	},
	methods: {
		cancelTest(test) {
			if (test && test.id) {
				this.$emit('cancelTest', test.id);
			}
		},
		previewResult(result) {
			this.$emit('previewResult', result);
		},
		getDuration(test) {
			return test.status !== RUN_STATUS.PENDING && test.status !== RUN_STATUS.SKIPPED ? convertDuration(test.duration) : '';
		}
	}
};
</script>

<style>
</style>
